import { HttpContextToken } from '@angular/common/http';

export const RECAPTCHA_TOKEN = new HttpContextToken<string>(() => '');

export const RECAPTCHA_TOKEN_HEADER = 'Recaptcha-Token';
